// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Ml9S3","fullView":"Footer_fullView__DOA0r","shimmer":"Footer_shimmer__TUG93"};